import React, { useEffect, useState } from 'react';
import { Input, message, Modal } from 'antd';
import { fetcher } from '../../../extras/fetcher';
import { ForkliftInterface } from '../../../types/forklift.interface';


export type AddForkliftType =
  Omit<ForkliftInterface, 'removed' | 'createdAt' | 'updatedAt' | 'id'> & {
  id?: string;
};
interface Props {
  open : boolean;
  handleSetModalOpened: (opened: boolean) => void;
  handleSetData: (data: ForkliftInterface) => void;
  forklift: AddForkliftType;

}
export const ModalAddForklift = (props: Props) => {


  const [moveLoading, setMoveLoading] = useState<boolean>(false);
  const [messageApi, contextHolder] = message.useMessage();

  const [inputValue, setInputValue] = useState<AddForkliftType>({
    ...props.forklift
  });




  const handleCancel = () => {
    props.handleSetModalOpened(false);
    setInputValue({
      number: '',
      comment: '',
      mark: '',
      model: '',
      serialNumber: '',
      id: '',
    });
  }

  const handleOk = async () => {
    setMoveLoading(true);




    if (inputValue.number === '') {
      messageApi.open({
        type: 'error',
        content: 'Numer wózka nie może być pusty!',
      });
      setMoveLoading(false);
      return;
    }

    if (inputValue.mark === '') {
      messageApi.open({
        type: 'error',
        content: 'Marka wózka nie może być pusta!',
      });
      setMoveLoading(false);
      return;
    }

    if (inputValue.model === '') {
      messageApi.open({
        type: 'error',
        content: 'Model wózka nie może być pusty!',
      });
      setMoveLoading(false);
      return;
    }


    if (inputValue.serialNumber === '') {
      messageApi.open({
        type: 'error',
        content: 'Numer seryjny wózka nie może być pusty!',
      });
      setMoveLoading(false);
      return;
    }


    let payload: AddForkliftType = inputValue;

    if(payload.id === '') {
      delete payload.id;
    }


    const data = await fetcher(`forklift`,payload.id ? 'PUT' : 'POST', inputValue);

    if(data.status === 403) {
      messageApi.open({
        type: 'error',
        content: 'Nie posiadasz wymaganych uprawnień!',
      });
      setMoveLoading(false);
      return;
    }

    if(data.result.error) {
      messageApi.open({
        type: 'error',
        content: data.result.error,
      });
    } else {
      messageApi.open({
        type: 'success',
        content: payload.id ? `Dane wózka zostały zapisane.` : `Wózek ${inputValue.number} dodany.`,
      });

      setInputValue({
        id: '',
        number: '',
        comment: '',
        mark: '',
        model: '',
        serialNumber: '',
      });

      const result: ForkliftInterface = data.result;

      props.handleSetData(result);
    }


    props.handleSetModalOpened(false);
    setMoveLoading(false);


    }






  const handleInputChange = (key: keyof AddForkliftType, value: string | number) => {
    setInputValue((prev) => ({...(prev || {}), [key]: value}));
  };


  useEffect(() => {
    if (props.open) {
      setInputValue({
        comment: props.forklift.comment ?? '',
        mark: props.forklift.mark ?? '',
        model: props.forklift.model ?? '',
        number: props.forklift.number ?? '',
        serialNumber: props.forklift.serialNumber ?? '',
        id: props.forklift.id ?? '',
      });
    }
  }, [props.open]);


  return (

<>
  <Modal
    bodyStyle={{padding: '20px'}}
    title={'Dodawanie Tripa'}
    open={props.open}
    onOk={handleOk}
    onCancel={handleCancel}
    confirmLoading={moveLoading}
    style={{borderRadius: '8px'}}
  >
    <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
      <label style={{marginBottom: '5px'}}>Marka</label>
      <Input
        value={inputValue.mark}
        onChange={(e) => handleInputChange('mark', e.target.value)}
        style={{width: '100%'}}
        placeholder={'Marka'}
      />
      <label style={{marginBottom: '5px'}}>Model</label>
      <Input
        value={inputValue.model}
        onChange={(e) => handleInputChange('model', e.target.value)}
        style={{width: '100%'}}
        placeholder={'Model'}
      />

      <label style={{marginBottom: '5px'}}>Numer wewnętrzny</label>
      <Input
        value={inputValue.number}
        onChange={(e) => handleInputChange('number', e.target.value)}
        style={{width: '100%'}}
        placeholder={'Numer wewnętrzny'}
      />

      <label style={{marginBottom: '5px'}}>Numer seryjny</label>
      <Input
        value={inputValue.serialNumber}
        onChange={(e) => handleInputChange('serialNumber', e.target.value)}
        style={{width: '100%'}}
        placeholder={'Numer seryjny'}
      />


      <label style={{marginBottom: '5px'}}>Komentarz</label>
      <Input
        value={inputValue.comment}
        onChange={(e) => handleInputChange('comment', e.target.value)}
        style={{width: '100%'}}
        placeholder={'Komentarz'}
      />
    </div>
  </Modal>
  {contextHolder}
</>
  );
}
